export default __webpack_public_path__ + "static/404-man@3x-61daac9395728b9ad01dda9be9f7b822.png";